__turbopack_context__.v({
  "base": "OFY-ha_base",
  "color-accent": "OFY-ha_color-accent",
  "color-error": "OFY-ha_color-error",
  "color-info": "OFY-ha_color-info",
  "color-jets-beige": "OFY-ha_color-jets-beige",
  "color-jets-black": "OFY-ha_color-jets-black",
  "color-jets-red": "OFY-ha_color-jets-red",
  "color-link": "OFY-ha_color-link",
  "color-neutral-100": "OFY-ha_color-neutral-100",
  "color-neutral-200": "OFY-ha_color-neutral-200",
  "color-neutral-300": "OFY-ha_color-neutral-300",
  "color-neutral-400": "OFY-ha_color-neutral-400",
  "color-neutral-500": "OFY-ha_color-neutral-500",
  "color-neutral-600": "OFY-ha_color-neutral-600",
  "color-neutral-700": "OFY-ha_color-neutral-700",
  "color-neutral-800": "OFY-ha_color-neutral-800",
  "color-neutral-900": "OFY-ha_color-neutral-900",
  "color-overImage": "OFY-ha_color-overImage",
  "color-overPrimary": "OFY-ha_color-overPrimary",
  "color-primary": "OFY-ha_color-primary",
  "color-success": "OFY-ha_color-success",
  "color-warning": "OFY-ha_color-warning",
});
